const initialStateFilters = {
  categoria: {},
  ciclo: {id: 1, name: 'Janeiro'},
  compararCiclos: {id: 'ativar', name: 'Ativar'},
  dataInicial: '',
  dataFinal: '',
  planejamento: {},
}

const initialState = {
  projetos: [],
  projeto: {},
  cliente: {},
  filters: {},
  filtersProvisorio: initialStateFilters,
  swots: [],
  loadSwots: false,
  totalAvaliacao: 0,
  listaPlanos: [],
  planoSelecionado: {},
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'LIST_PROJETOS':
      return { ...state, projetos: payload}
    case 'INFO_PROJETO':
      return { ...state, projeto: payload}
    case 'INFO_CLIENTE':
      return { ...state, cliente: payload}
    case 'INFO_FILTERS_PLANO':
      return { ...state, filters: payload}
    case 'INFO_FILTERS_SWOTS':
      return { ...state, filtersProvisorio: payload}
    case 'CHANGE_FILTERS_SWOTS':
      return { ...state, filtersProvisorio: {...state.filtersProvisorio, [payload.name]: payload.value}}
    case 'CLEAN_FILTERS_SWOTS':
      return { ...state, filtersProvisorio: initialStateFilters}
    case 'LIST_SWOTS':
      return { ...state, swots: payload}
    case 'LOAD_LIST_SWOTS':
      return { ...state, loadSwots: payload}
    case 'INFO_SWOTS_TOTAL_AVALIACAO':
      return { ...state, totalAvaliacao: payload}
    case 'PLANO30DIAS_LIST_PLANOS':  // ← Apenas este mudado
      return { ...state, 
        listaPlanos: payload.planejamentos, 
        planoSelecionado: payload.planejamentoescolhido, 
        filtersProvisorio: {...state.filtersProvisorio, planejamento: payload.planejamentoescolhido}
      }
      case 'RESET_PLANEJAMENTO':
        return {
          ...state,
          filtersProvisorio: {
            ...state.filtersProvisorio,
            planejamento: {}
          }
        }
      
      
    default:
      return state
  }
}


